import React, {Component} from 'react';

import tepesa from "./tepesa.png";
import tepasa from "./tepasa.png";

import "./Layout.css";

import Menu from "./Menu";

export default class Layout extends Component {
	render() {
		return (
			<div>
				<header className="row small-12">
					<div className="columns small-3 text-center tepasa">
						<img src={tepasa} alt="Logo"/>
					</div>
					<div className="small-6">
						<Menu/>
					</div>
					<div className="columns small-3 logo-tepasa">
						<img src={tepesa} alt="Logo"/>
					</div>
				</header>
				<div>
					{this.props.children}
				</div>
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Layout.js
 **/